import { PARAM_LEGS_DURATION } from '@optionway/models';

interface LegDurationFilter {
  durationValue: number;
}

interface DurationFilterStore {
  legs: [LegDurationFilter, LegDurationFilter];
}

const DURATION_FILTER_DEFAULTS: DurationFilterStore = {
  legs: [{ durationValue: 24 }, { durationValue: 24 }],
};

export const useDurationFilterStore = defineStore('filters/duration', {
  state: (): DurationFilterStore => ({
    legs: [
      { durationValue: DURATION_FILTER_DEFAULTS.legs[0].durationValue },
      { durationValue: DURATION_FILTER_DEFAULTS.legs[1].durationValue },
    ],
  }),
  getters: {
    hasActiveFilters: (state) =>
      state.legs.some((l) => l.durationValue !== DURATION_FILTER_DEFAULTS.legs[0].durationValue),
    // durationValue === 0 means max travel time of 0 hours — no flight can satisfy this.
    isImpossible: (state) => state.legs.some((leg) => leg.durationValue === 0),
    maxTravelTimeByLeg: (state) => state.legs.map((leg) => (leg.durationValue < 24 ? leg.durationValue : undefined)),
    filterQueryString(): string {
      if (!this.hasActiveFilters) return '';
      const parameters = new URLSearchParams();
      for (const leg of this.legs) parameters.append(PARAM_LEGS_DURATION, String(leg.durationValue));
      return parameters.toString();
    },
  },
  actions: {
    // legs.duration is positional like legs.from: one occurrence per leg.
    applyFromUrlQuery(url: string) {
      this.$reset();
      const parameters = new URL(url, 'https://dummy.com').searchParams;
      const durations = parameters.getAll(PARAM_LEGS_DURATION);
      for (const [index, leg] of this.legs.entries()) {
        const value = Number.parseInt(durations[index] ?? '', 10);
        if (!Number.isNaN(value)) leg.durationValue = Math.min(Math.max(value, 1), 24);
      }
    },
  },
});
